import { Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrencyPipe } from '@angular/common';
import { ModalP2pDowloadQRCardsService } from 'app/manage-p2p/services/modal-p2p-dowload-qr-cards/modal-p2p-dowload-qr-cards.service';
import { ToastService } from 'app/toast/services/toast.service';
import { Store, select } from '@ngrx/store';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { selectP2PCampaignsList } from 'app/manage-p2p/features/p2p.selectors';
import { ModalP2pAddFundrasingService } from 'app/manage-p2p/services/modal-p2p-add-fundrasing/modal-p2p-add-fundrasing.service';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalP2pAddBulkMilestonesService } from 'app/manage-p2p/services/modal-p2p-add-bulk-milestones/modal-p2p-add-bulk-milestones.service';
import { ModalFullfillBulkPledgesService } from 'app/manage-p2p/services/modal-fulfill-bulk-donor-pledges/modal-fulfill-bulk-donor-pledges.service';

@Component({
  standalone:true,
  selector: 'app-peer-to-peer-card',
  templateUrl: './peer-to-peer-card.component.html',
  styleUrls: ['./peer-to-peer-card.component.scss'],
  imports:[CurrencyPipe]
})

export class PeerToPeerCardComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public newP2PCampaigns$: any = this.store.pipe(
    select(selectP2PCampaignsList)
  );

  @Input () peerToPeer = null

  public currentP2P = null;
  public orgId = null;

  public image = '';
  public p2pDonorImages = [];
  public raised = null;
  public progressBarHtml = null;
  public isModalOpen = false;
  public pledgePerEvent: boolean = false; 
  
  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  constructor( 
    public peerToPeerManageService: PeerToPeerManageService,
    private sanitizer: DomSanitizer,
    public router: Router,
    public modalP2pDowloadQRCardsService: ModalP2pDowloadQRCardsService,
    private toastService: ToastService,
    private store: Store,
    private modalP2pAddFundrasingService: ModalP2pAddFundrasingService,
    private authService: AuthService,
    private modalService: MdbModalService,
    private modalP2pAddBulkMilestonesService: ModalP2pAddBulkMilestonesService,    
    private modalP2pFulfillBulkPledgesService: ModalFullfillBulkPledgesService
  ) { }

  ngOnInit() {
    this.newP2PCampaigns$.pipe(
      filter((list:any)=> list.length > 0),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((P2PCampaigns)=>{
      const filteredP2P = P2PCampaigns.filter((campaign) => campaign.id === this.peerToPeer.id);
      this.currentP2P = filteredP2P[0];

      this.image = this.currentP2P.imageUrl ? this.currentP2P.imageUrl : "/images/org_logo_default_v2.svg";
      const fundraisers = this.currentP2P.campaignTypeData.p2pCampaigns || [];
      this.raised = this.currentP2P.raised || this.getRaised(fundraisers);
      this.progressBarHtml = this.getProgressBarHtml(this.currentP2P);
      this.pledgePerEvent = this.currentP2P.campaignTypeData.pledgePerEvent;
      
      this.getUserImages(fundraisers);
    });

    this.authService.getOrgUser().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((orgUser) => {
      this.orgId = orgUser.id
    })
  }

  getRaised(fundraisers) {
    let amount = 0;

    for (let i = 0; i < fundraisers.length; i++) {
      const transactions = fundraisers[i].transactions || [];
      for (let j = 0; j < transactions.length; j++) {
        amount += transactions[j].amount;
      }
    }

    return amount;
  }

  getUserImages(fundraisers) {
    let userImages = [];
    for (let i = 0; i < fundraisers.length; i++) {
      let userImage = {
        id: i,
        imageUrl: fundraisers[i].profileImage || fundraisers[i].userInfo.image || "/images/org_logo_default_v2.svg",
      };
      
      userImages.push(userImage);
    }
    this.p2pDonorImages = userImages;
  }

  getProgressBarHtml (p2pCampaign) {
    const { campaignTypeData: {goal} } = p2pCampaign;

    if (goal === 0 ||
      this.raised > goal) {
      var progressValue = 100
    } else {
      var progressValue = (this.raised/goal) * 100
    }

    var progressBarHtml = `<div role="progressbar" aria-valuenow="${progressValue}" 
      aria-valuemin="0" aria-valuemax="100" class="progress-bar active p2p-progress" 
      style="width: ${progressValue}%"></div>`

    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(progressBarHtml);
    return sanitizedHtml;
  }

  openP2PDetailsPage(id,event){
    if(!event.target.matches('.noDetaisClick')){
      this.router.navigate([`/manage/p2p/${id}`], { fragment: "championsTab" })
    }

  }

  onClickDownloadQRCards(event){
    event.stopPropagation();
    this.peerToPeerManageService.getDownloadQRCards(this.peerToPeer.id).subscribe((data:any)=>{
      this.isModalOpen = true;

      const modalRef = this.modalP2pDowloadQRCardsService.open({fileName: data.fileName});
      
      modalRef.onClose.pipe().subscribe(() =>{
        this.modalP2pDowloadQRCardsService.modalRef = null;
        this.isModalOpen = false;
      })
    });
  }

  onClickFulfillBulkPledges(event){
    event.stopPropagation();

    const modalRef = this.modalP2pFulfillBulkPledgesService.open({
      campaign: this.currentP2P,
      placeOfCall: 'campaign-card'
    });

    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pFulfillBulkPledgesService.modalRef = null;
    })
  }

  onClickAddBulkMilestones(event) {
    event.stopPropagation();

    const modalRef = this.modalP2pAddBulkMilestonesService.open({
      campaign: this.currentP2P,
      placeOfCall: 'campaign-card'
    });
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddBulkMilestonesService.modalRef = null;
    })
  }

  onClickCreate(event) {
    event.stopPropagation();
    const modalRef = this.modalP2pAddFundrasingService.open({
      orgId: this.orgId,
      campaign: this.currentP2P,
      loadCampaignList: true
    });
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddFundrasingService.modalRef = null;
    })
  }

  onClickImport(event) {
    event.stopPropagation();

    const teams = this.currentP2P.campaignTypeData.teams || [];

    const action = DialogActions.openDialog({
      payload: {
        name: "importChampions",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          teams: teams,
          campaignId: this.currentP2P.id,
          loadCampaignList: true,
        }
      }
    });
    this.store.dispatch(action);
  }

  onClickNotifyAll(event) {
    event.stopPropagation();
    const type = "sendFundraisersProgressReminder";
    let params = {
      campaignId: this.currentP2P.id,
    }


    const title = `Send reminder to all champions`
    const message = `Send fundraiser progress updates to all champions`
    window['orgMain'].showSendSimpleReminderModal(title, message, params, type) 
    return;
    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `Send fundraiser progress updates to all champions.`,
        onClose: (status)=>{
          this.modalRef.close();
          if(status){
            this.peerToPeerManageService.notify(this.currentP2P.id).pipe(
              takeUntilDestroyed(this.destroyRef)
            ).subscribe(() => {
              this.toastService.show('success', 'Reminders sent!', {delay: 2000});
            });
          }
        }
      }
    });
    
  }
}
